import { Form, DatePicker, Typography, ConfigProvider } from "antd";
import React from "react";
import { useController, useFormContext } from "react-hook-form";
import { useMode } from "../../organisms";
import dayjs from "dayjs";
import { FormIteam } from "../GlobalControl.styled";
import "dayjs/locale/pl";
import locale from "antd/lib/locale/pl_PL";
dayjs.locale("pl");

const DATE_FORMAT = "YYYY-MM-DD";

const parseRangeValue = (
  value: unknown
): [dayjs.Dayjs | null, dayjs.Dayjs | null] => {
  if (!value) return [null, null];
  const parts = Array.isArray(value)
    ? value
    : String(value).split(",");
  return [
    parts[0] ? dayjs(parts[0], DATE_FORMAT) : null,
    parts[1] ? dayjs(parts[1], DATE_FORMAT) : null,
  ];
};

export const DataPickerRange: React.FC<{ control: any }> = ({ control }) => {
  const pre_name =
    control.pre_name && control.pre_name !== "" ? `${control.pre_name}.` : "";
  const {
    field,
    fieldState: { invalid, error },
  } = useController({ name: `${pre_name}${control.uuid}` });
  const methods = useFormContext();
  const { mode } = useMode();
  if (mode === "edit") {
    return (
      <Form.Item
        label={control.field_name}
        // tooltip={
        //   !control.writeable && mode === "edit"
        //     ? "Brak uprawnień do edycji"
        //     : control.description
        // }
        required={control.required}
        validateStatus={invalid ? "error" : undefined}
        help={invalid ? error?.message : null}
      >
        <ConfigProvider locale={locale}>
          <DatePicker.RangePicker
            disabled={!control.writeable}
            style={{
              width: "100%",
            }}
            allowClear={false}
            {...field}
            value={parseRangeValue(field.value)}
            onChange={(_, value) =>
              methods.setValue(`${pre_name}${control.uuid}`, value)
            }
            format={DATE_FORMAT}
          />{" "}
        </ConfigProvider>
      </Form.Item>
    );
  }

  return (
    <FormIteam
      label={control.field_name}
      // tooltip={control.description}
    >
      <Typography.Text strong copyable={control.value}>
        {control.value}
      </Typography.Text>
    </FormIteam>
  );
};
